// Login-10
export const PERSIST_LOGIN = 'PERSIST_LOGIN';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_RESPONSE = 'LOGIN_RESPONSE';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_RESPONSE = 'RESET_PASSWORD_RESPONSE';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const RESET_PASSWORD_CONFIRM_REQUEST = 'RESET_PASSWORD_CONFIRM_REQUEST';
export const RESET_PASSWORD_CONFIRM_RESPONSE = 'RESET_PASSWORD_CONFIRM_RESPONSE';
export const RESET_PASSWORD_CONFIRM_FAILED = 'RESET_PASSWORD_CONFIRM_FAILED';
// Logout
export const LOG_OUT = 'LOG_OUT';

// Sign up - 11
export const CHECK_TERMS_CONDITIONS = 'CHECK_TERMS_CONDITIONS';
export const PERSIST_SIGNUP = 'PERSIST_SIGNUP';
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_RESPONSE = 'SIGNUP_RESPONSE';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';
export const CONFIRM_SIGNUP_REQUEST = 'CONFIRM_SIGNUP_REQUEST';
export const CONFIRM_SIGNUP_RESPONSE = 'CONFIRM_SIGNUP_RESPONSE';
export const CONFIRM_SIGNUP_FAILED = 'CONFIRM_SIGNUP_FAILED';
export const RESEND_CODE_REQUEST = 'RESEND_CODE_REQUEST';
export const RESEND_CODE_RESPONSE = 'RESEND_CODE_RESPONSE';
export const RESEND_CODE_FAILED = 'RESEND_CODE_FAILED';

//Patient-19
export const UPDATE_PATIENT_FIRSTNAME = 'UPDATE_PATIENT_FIRSTNAME';
export const UPDATE_PATIENT_LASTNAME = 'UPDATE_PATIENT_LASTNAME';
export const UPDATE_PATIENT_DOB = 'UPDATE_PATIENT_DOB';
export const UPDATE_PATIENT_DUE_DATE = 'UPDATE_PATIENT_DUE_DATE';
export const UPDATE_PATIENT_GENDER = 'UPDATE_PATIENT_GENDER';
export const UPDATE_PATIENT_COUNTRY = 'UPDATE_PATIENT_COUNTRY';
export const UPDATE_PATIENT_SECONDARY_COUNTRY = 'UPDATE_PATIENT_SECONDARY_COUNTRY';
export const UPDATE_PATIENT_PHONETYPE = 'UPDATE_PATIENT_PHONETYPE';
export const UPDATE_PATIENT_PHONETYPE_2 = 'UPDATE_PATIENT_PHONETYPE_2';
export const UPDATE_PATIENT_PHONETYPE_3 = 'UPDATE_PATIENT_PHONETYPE_3';
export const UPDATE_PATIENT_PHONETYPE_4 = 'UPDATE_PATIENT_PHONETYPE_4';
export const UPDATE_PATIENT_LANGUAGES = 'UPDATE_PATIENT_LANGUAGES';
export const UPDATE_PATIENT_NEEDINTERPRETER = 'UPDATE_PATIENT_NEEDINTERPRETER';
export const UPDATE_PATIENT_PCPLETTER = 'UPDATE_PATIENT_PCPLETTER';
export const UPDATE_PATIENT_CARDIOLOGISTLETTER = 'UPDATE_PATIENT_CARDIOLOGISTLETTER';
export const PERSIST_PATIENT_INFO = 'PERSIST_PATIENT_INFO';
export const PERSIST_PATIENT_CONTACT_INFO = 'PERSIST_PATIENT_CONTACT_INFO';
export const PERSIST_PATIENT_MD_INFO = 'PERSIST_PATIENT_MD_INFO';
export const PERSIST_PATIENT_BCH_INFO = 'PERSIST_PATIENT_BCH_INFO';

// Case-9
export const GET_ALL_MY_CASES = 'GET_ALL_MY_CASES';
export const GET_ALL_MY_CASES_RESPONSE = 'GET_ALL_MY_CASES_RESPONSE';
export const GET_ALL_MY_CASES_FAIL = 'GET_ALL_MY_CASES_FAIL';
export const SET_CASE_TYPE = 'SET_CASE_TYPE';
export const CLEAR_CASE = 'CLEAR_CASE';
export const CLEAR_CASE_THEN_NAVIGATE_REQUEST = 'CLEAR_CASE_THEN_NAVIGATE_REQUEST';
export const SET_CASE_ID = 'SET_CASE_ID';
export const SET_LOCAL_COUNTRYNAME = 'SET_LOCAL_COUNTRYNAME';
// create
export const CREATE_CASE_REQUEST = 'CREATE_CASE_REQUEST';
export const CREATE_CASE_RESPONSE = 'CREATE_CASE_RESPONSE';
export const CREATE_CASE_FAILED = 'CREATE_CASE_FAILED';

// Update About you-12
export const UPDATE_CASE_BASICINFO_REQUEST = 'UPDATE_CASE_BASICINFO_REQUEST';
export const UPDATE_CASE_BASICINFO_RESPONSE = 'UPDATE_CASE_BASICINFO_RESPONSE';
export const UPDATE_CASE_BASICINFO_FAILED = 'UPDATE_CASE_BASICINFO_FAILED';

// Update Contact me
export const UPDATE_CASE_CONTACTINFO_REQUEST = 'UPDATE_CASE_CONTACTINFO_REQUEST';
export const UPDATE_CASE_CONTACTINFO_RESPONSE = 'UPDATE_CASE_CONTACTINFO_RESPONSE';
export const UPDATE_CASE_CONTACTINFO_FAILED = 'UPDATE_CASE_CONTACTINFO_FAILED';

// Update MD info
export const UPDATE_CASE_MDINFO_REQUEST = 'UPDATE_CASE_MDINFO_REQUEST';
export const UPDATE_CASE_MDINFO_RESPONSE = 'UPDATE_CASE_MDINFO_RESPONSE';
export const UPDATE_CASE_MDINFO_FAILED = 'UPDATE_CASE_MDINFO_FAILED';

// Update BCH info
export const UPDATE_CASE_BCHINFO_REQUEST = 'UPDATE_CASE_BCHINFO_REQUEST';
export const UPDATE_CASE_BCHINFO_RESPONSE = 'UPDATE_CASE_BCHINFO_RESPONSE';
export const UPDATE_CASE_BCHINFO_FAILED = 'UPDATE_CASE_BCHINFO_FAILED';

// Account - 21
export const CREATE_ACCOUNT_REQUEST = 'CREATE_ACCOUNT_REQUEST';
export const CREATE_ACCOUNT_FAILED = 'CREATE_ACCOUNT_FAILED';
export const CREATE_ACCOUNT_RESPONSE = 'CREATE_ACCOUNT_RESPONSE';

export const UPDATE_FIRSTNAME_REQUEST = 'UPDATE_FIRSTNAME_REQUEST';
export const UPDATE_FIRSTNAME_RESPONSE = 'UPDATE_FIRSTNAME_RESPONSE';
export const UPDATE_FIRSTNAME_FAILED = 'UPDATE_FIRSTNAME_FAILED';

export const UPDATE_LASTNAME_REQUEST = 'UPDATE_LASTNAME_REQUEST';
export const UPDATE_LASTNAME_RESPONSE = 'UPDATE_LASTNAME_RESPONSE';
export const UPDATE_LASTNAME_FAILED = 'UPDATE_LASTNAME_FAILED';

export const UPDATE_EMAIL_REQUEST = 'UPDATE_EMAIL_REQUEST';
export const UPDATE_EMAIL_RESPONSE = 'UPDATE_EMAIL_RESPONSE';
export const UPDATE_EMAIL_FAILED = 'UPDATE_EMAIL_FAILED';

export const UPDATE_PHONE_REQUEST = 'UPDATE_PHONE_REQUEST';
export const UPDATE_PHONE_RESPONSE = 'UPDATE_PHONE_RESPONSE';
export const UPDATE_PHONE_FAILED = 'UPDATE_PHONE_FAILED';

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_RESPONSE = 'UPDATE_PASSWORD_RESPONSE';
export const UPDATE_PASSWORD_FAILED = 'UPDATE_PASSWORD_FAILED';

export const GET_PHONE_REQUEST = 'GET_PHONE_REQUEST';
export const GET_PHONE_FAILED = 'GET_PHONE_FAILED';
export const GET_PHONE_RESPONSE = 'GET_PHONE_RESPONSE';

// others - 3
export const CLEAR_ERROR = 'CLEAR_ERROR';

export const GET_CASE_BY_ID_REQUEST = 'GET_CASE_BY_ID_REQUEST';

export const SET_DATA_UPDATED = 'SET_DATA_UPDATED';

export const SET_VIEW_SUMMARY = 'SET_VIEW_SUMMARY';

export const SET_SAVE_BASICINFO = 'SET_SAVE_BASICINFO';
export const SET_SAVE_CONTACTINFO = 'SET_SAVE_CONTACTINFO';
export const SET_SAVE_MDINFO = 'SET_SAVE_MDINFO';
export const SET_SAVE_ADDITIONALINFO = 'SET_SAVE_ADDITIONALINFO';
export const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
export const SET_SIGNUP_ACTIVE_STEP = 'SET_SIGNUP_ACTIVE_STEP';

export const ACCESS_CASE_REQUEST = 'ACCESS_CASE_REQUEST';
export const ACCESS_CASE_FAILED = 'ACCESS_CASE_FAILED';
export const ACCESS_CASE_RESPONSE = 'ACCESS_CASE_RESPONSE';

export const SET_SHOW_WELCOME = 'SET_SHOW_WELCOME';
